@let blok = block();
@let appear = appearance();
@let siz = size();
@let selectedIconActive = selectedIconActiveBlok();
@let selectedIcon = selectedIconBlok();
@let unselectedIcon = unselectedIconBlok();

<ng-template #entryTemplate let-size="size" let-includesTariff="includesTariff">
    <div [class]="baseClass + '--entry'"
         class="flex md:bg-primary10 px-4 py-0.5 md:py-2 w-full"
         [class.is-selected]="size === tariffStore.size$()"
         [class.is-topseller]="size === topsellerTariff()"
         (click)="tariffStore.selectSize(size)"
         (keydown.enter)="tariffStore.selectSize(size)"
         [tabindex]="-1">
        @if (includesTariff) {
            @if (selectedIconActive) {
                <s1-image [block]="selectedIconActive"
                          class="block mx-auto"
                          [class]="baseClass + '--icon'"
                          [class.md:mx-0]="appear === '3-columns'"
                          [class.hidden]="size !== tariffStore.size$() || (media.isUnderMd$ | async)" />
            }

            @if (selectedIcon) {
                <s1-image [block]="selectedIcon"
                          class="block mx-auto"
                          [class]="baseClass + '--icon'"
                          [class.md:mx-0]="appear === '3-columns'"
                          [class.hidden]="size === tariffStore.size$() && (media.isUnderMd$ | async) === false" />
            }

        } @else {
            @if (unselectedIcon) {
                <s1-image [block]="unselectedIcon"
                          class="block mx-auto"
                          [class]="baseClass + '--icon'"
                          [class.md:mx-0]="appear === '3-columns'" />
            }
        }
        @if (appear === '3-columns') {
            <span
                class="hidden md:block items-center text-left ml-2 flex-grow-0 flex-shrink md:break-words md:hyphens-auto min-[890px]:break-normal min-[890px]:hyphens-manual">
        {{ blok.title }}
      </span>
            @if (blok.tooltipDescription?.length) {
                <button
                    class="!hidden md:!flex justify-center items-center cursor-pointer md:ml-auto mr-1 !overflow-visible"
                    (click)="toggleDrawer(drawer, $event)"
                    #openButton
                    [attr.aria-describedby]="id">
                    <mat-icon
                        class="text-secondary50"
                        appTooltip
                        position="below"
                        aria-hidden="false"
                        [tooltip]="blok.tooltipDescription || ''"
                        [tooltipDisabled]="!blok.tooltipDescription?.length">
                        info
                    </mat-icon>
                </button>
                <p class="sr-only" [id]="id">{{ blok.tooltipDescription }}</p>
            }
        }
    </div>
</ng-template>


<div [class]="baseClass + '--title'"
     [class.hidden]="appear !== '4-columns'"
     [class.flex]="appear === '4-columns'"
     class="py-2 pl-6 pr-2 md:break-words md:hyphens-auto min-[890px]:break-normal min-[1080px]:hyphens-manual">
    {{ blok.title }}
    @if (blok.tooltipDescription?.length) {
        <button
            class="!hidden md:!flex justify-center items-center cursor-pointer md:ml-auto mr-1 !overflow-visible"
            (click)="toggleDrawer(drawer, $event)"
            (keydown.enter)="toggleDrawer(drawer, $event)"
            #openButton
            [attr.aria-describedby]="id">
            <mat-icon
                class="text-secondary50"
                appTooltip
                position="below"
                aria-hidden="false"
                [tooltip]="blok.tooltipDescription || ''"
                [tooltipDisabled]="!blok.tooltipDescription?.length">
                info
            </mat-icon>
        </button>
        <p class="sr-only" [id]="id">{{ blok.tooltipDescription }}</p>
    }
</div>
<div [class]="baseClass + '--mobile-title'"
     class="flex items-center md:hidden text-center py-2 justify-center relative">
    <span class="mx-8">{{ blok.title }}</span>
    @if (blok.tooltipDescription?.length) {
        <button
            class="flex justify-center items-center cursor-pointer !overflow-visible right-2 absolute"
            (click)="toggleDrawer(drawer, $event)"
            (keydown.enter)="toggleDrawer(drawer, $event)"
            #openButton
            [attr.aria-describedby]="id">
            <mat-icon
                class="text-secondary50"
                appTooltip
                position="below"
                aria-hidden="false"
                [tooltip]="blok.tooltipDescription || ''"
                [tooltipDisabled]="!blok.tooltipDescription?.length">
                info
            </mat-icon>
        </button>
        <p class="sr-only" [id]="id">{{ blok.tooltipDescription }}</p>
    }
</div>
<!-- size only set, when 3-column and desktop layout -->
<!-- todo: is in wrong case here -->
@if (siz) {
    <ng-container *ngTemplateOutlet="entryTemplate;context:{size:siz, includesTariff: siz | includesTariffSize: blok.tariffTypes || []}" />
} @else {
    @for (i of [0, 1, 2]; track i) {
        <ng-container
            *ngTemplateOutlet="entryTemplate;context:{size: i | indexToTariffSize, includesTariff: i | indexToTariffSize | includesTariffSize: blok.tariffTypes || []}" />
    }
}

<div app-drawer [isActive]="drawerActive()" (isActiveChange)="drawerActive.set($event)" #drawer>
    <p class="mb-4 text-2xl font-bold">
        {{ blok.title }}
    </p>
    @if (blok.tooltipDescription?.length) {
        <p>
            {{ blok.tooltipDescription }}
        </p>
    }
</div>
